export default __webpack_public_path__ + "3157ca979e665f27c77a234d3d59fe21.png";